import { ReactNode } from "react";

import { Paper } from "@mui/material";

import { menuDrawerStyles } from "../menuDrawer.styles";

interface SubMenuProps {
  drawerMaxWidth: number;
  isMobile: boolean;
  showSubMenuBehindMainMenu: boolean;
  subMenuOpen: boolean;
  subMenuListItems: ReactNode;
}

const SubMenu = ({
  drawerMaxWidth,
  isMobile,
  showSubMenuBehindMainMenu,
  subMenuListItems,
  subMenuOpen,
}: SubMenuProps) => {
  if (!showSubMenuBehindMainMenu) return null;
  return (
    <Paper
      square
      data-testid="sub-menu-drawer"
      css={[
        menuDrawerStyles.drawer({ drawerMaxWidth }),
        menuDrawerStyles.subMenuDrawer({ drawerMaxWidth }),
        !isMobile && menuDrawerStyles.transition,
        subMenuOpen && !isMobile && menuDrawerStyles.slide,
      ]}
      aria-live="polite"
    >
      {subMenuListItems}
    </Paper>
  );
};

export default SubMenu;
